export const STATIC_ASSETS_CDN_URL = 'https://static.nib.com.au';
export const FONTS_CDN_URL = `${STATIC_ASSETS_CDN_URL}/fonts`;
